function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
export function AvatarGirl(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 100 92"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 91.164c.114-2.098 1.926-5.279 4.478-6.415 6.837-3.045 30.188-9.923 33.587-14.164 1.794-2.238 2.494-5.284-.356-7.415-2.541-2.06-6.145-4.553-8.504-7.288-.922-1.542-2.187-3.913-4.481-3.392-3.245.086-7.66-9.601-4.965-12.874.235-.256.959-.681 1.242-.925 1.079-.462 1.49-.891.682-3.635-.295-1.002-.655-1.313-1.684-1.591-1.883-.508-2.953 2.907-2.98 6.13-.032 3.71 1.499 7.6.797 9.819-.88 2.771-4.325 4-4.883 2.422-.307-.864.135-3.067-1.543-4.316-12.708-9.461-5.81-32.93 7.188-25.942 2.04 1.096 2.884 1.926 3.23-.025.81-4.559 3.392-12.038 13.501-18.342C37.82 1.646 44.477-.56 47.228.131c.814.204 1.34.69 1.45 1.172.168.741 1.547.741 1.716 0 .11-.481.636-.968 1.45-1.173 2.75-.69 9.408 1.516 11.918 3.081 10.11 6.304 12.692 13.783 13.502 18.342.346 1.95 1.189 1.121 3.23.025 12.997-6.988 19.895 16.48 7.188 25.942-1.679 1.249-1.237 3.452-1.543 4.316-.56 1.578-4.005.35-4.882-2.422-.703-2.218.828-6.109.796-9.818-.027-3.224-1.098-6.639-2.98-6.131-1.03.278-1.39.59-1.686 1.591-.805 2.744-.395 3.173.683 3.635.284.244 1.008.669 1.243.925 2.694 3.273-1.72 12.96-4.965 12.874-2.294-.52-3.56 1.85-4.48 3.392-2.36 2.735-5.964 5.229-8.505 7.288-2.85 2.131-2.15 5.177-.356 7.415 3.398 4.24 26.75 11.119 33.586 14.164 2.552 1.136 4.364 4.317 4.478 6.415H0"
  }));
}